import { IDimmerState } from '@/types/IDimmerState';
import { getLocalStorageValue } from '@/utils/getLocalStorageValue';

export const getIsDimmerShown = () => {
  const dimmerStatus = getLocalStorageValue<IDimmerState>('DIMMER_STATUS');
  return dimmerStatus !== 'HIDDEN';
};
